"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptinMonsterScript = void 0;
var _react = require("react");
/* 
To be used in conjunction with optinMonsterReset. 
Example implementation in index.js:

const currentEnv = process.env.REACT_APP_ENV;
const allowedEnvs = ['production', 'local'];

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <OptinMonsterScript currentEnv={currentEnv} allowedEnvs={allowedEnvs} />
*/

const OptinMonsterScript = _ref => {
  let {
    currentEnv,
    allowedEnvs
  } = _ref;
  (0, _react.useEffect)(() => {
    if (allowedEnvs.includes(currentEnv)) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = "\n        (function(d,u,ac){\n          var s=d.createElement('script');\n          s.type='text/javascript';\n          s.src='https://a.omappapi.com/app/js/api.min.js';\n          s.async=true;\n          s.dataset.user=u;\n          s.dataset.account=ac;\n          d.getElementsByTagName('head')[0].appendChild(s);\n        })(document,27375,2863);\n      ";
      document.body.appendChild(script);
    }
  }, [currentEnv, allowedEnvs]);
  return null;
};
exports.OptinMonsterScript = OptinMonsterScript;